export default "__VITE_ASSET__D3pg2ztm__"